<script setup lang="ts">
import DateTimeFormatter from '@/components/formatters/DateTimeFormatter.vue';
import { I18nKey } from '@/utils/typings';
import { instanceOfMedicalComponentTaskType, TaskTypeBase } from '@/api/generator';
import { computed } from 'vue';
import { formatVersion } from '@/utils/stringUtils';
import { EMPTY_FIELD_SIGN } from '../forms/utils';

interface ModuleInfoProp {
  data: TaskTypeBase;
}

const props = defineProps<ModuleInfoProp>();
const version = computed(() =>
  props.data.version ? formatVersion(props.data.version) : EMPTY_FIELD_SIGN,
);
</script>

<template>
  <p class="text-h6">
    {{ $t((data.nameKey as I18nKey) || 'FrameworkModuleName') }}
  </p>
  <template v-if="instanceOfMedicalComponentTaskType(data)">
    <div class="text-body-3">
      <img class="icon" :src="`data:image/png;base64,${data.mdIcon}`" alt="Medical Device Icon" />{{
        ' '
      }}
      <img class="ceIcon mr-6" :src="`data:image/png;base64,${data.ceIcon}`" alt="CE Icon" />
    </div>
    <div class="text-body-3">
      <img class="icon" :src="`data:image/png;base64,${data.udiIcon}`" alt="UDI Icon" />
      {{ data.udiNumber }}<br />
      <img class="qrCode" :src="`data:image/png;base64,${data.dataMatrixCode}`" alt="UDI QR Code" />
    </div>
  </template>
  <div class="text-body-3">
    <img
      class="icon"
      :src="`data:image/png;base64,${props.data.refIcon}`"
      alt="Reference Number Icon"
    />
    {{ data.referenceNumber }}
  </div>
  <div class="text-body-3">
    <img class="icon" :src="`data:image/png;base64,${props.data.hashIcon}`" alt="Hash Icon" />
    {{ version }} (<DateTimeFormatter :value="data.releaseDate" format="isoDateOnly" />)
  </div>
</template>

<style lang="scss" scoped>
.icon {
  height: 30px;
  vertical-align: middle;
  margin-right: 8px;
}
.qrCode {
  height: 50px;
  margin-left: 38px;
  vertical-align: middle;
}
.ceIcon {
  vertical-align: middle;
  height: 20px;
}
.text-h6 {
  text-wrap: nowrap;
}
</style>
